import React, { FunctionComponent } from 'react';

import { getImageData } from 'lib/get-image-data';
import Image from 'lib/image-container';
import { MediaQueryWidth } from 'lib/use-media-query';
import useScrollbarWidth from 'lib/use-scrollbar-width';

import { CtaBox, CtaBoxContent, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import PageSection from 'components/page/page-section';
import { Header1 } from 'components/typography';

const PAGE_PADDING_SMALL = '16px';
const PAGE_PADDING_MEDIUM = '64px';
const PAGE_PADDING_LARGE = '108px';

type Props = {
  titleElement?: string;
  title?: string;
  subtitle: string | React.ReactNode;
  image?: {
    src: string;
    objectPosition: string;
    hasLoadPriority?: boolean;
  };
  color?: 'orange' | 'yellow' | 'white' | 'peach';
};

const PageSectionAboutHero: FunctionComponent<Props> = ({
  titleElement,
  title,
  subtitle,
  image,
  color = 'yellow',
}) => {
  const scrollbarWidth = useScrollbarWidth(true);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const handleImageLoaded = () => setIsLoaded(true);
  const blurDataUrl = image ? getImageData(image.src).blurDataUrl : null;

  return (
    <PageSection color={color} padding="block" inner={true} extraClass="about-hero">
      <CtaBox align="center">
        {titleElement ? (
          <CtaBoxHeader>
            <Header1 html={titleElement}></Header1>
          </CtaBoxHeader>
        ) : (
          <CtaBoxHeader tag="div">{title}</CtaBoxHeader>
        )}
        <CtaBoxText>{subtitle}</CtaBoxText>
        {image && (
          <CtaBoxContent width="stretch">
            <div
              className="page-section__picture"
              style={
                blurDataUrl
                  ? {
                      backgroundImage: `url("${blurDataUrl}")`,
                      backgroundSize: 'cover',
                      backgroundPosition: image.objectPosition,
                    }
                  : undefined
              }
            >
              <Image
                priority={image.hasLoadPriority}
                width={1218}
                height={508}
                style={{
                  objectFit: 'cover',
                  objectPosition: image.objectPosition,
                  opacity: blurDataUrl && !isLoaded ? 0 : 1,
                  transition: 'opacity 0.5s',
                }}
                quality={75}
                src={image.src}
                alt=""
                onLoad={handleImageLoaded}
                sizes={`
                                (max-width: ${MediaQueryWidth['desktop-sm']}px) calc(100vw - 2 * ${PAGE_PADDING_SMALL} - ${scrollbarWidth}),
                                (max-width: ${MediaQueryWidth['tablet-lg']}px) calc(100vw - 2 * ${PAGE_PADDING_MEDIUM} - ${scrollbarWidth}),
                                (max-width: ${MediaQueryWidth['content-max']}px) calc(100vw - 2 * ${PAGE_PADDING_LARGE} - ${scrollbarWidth}),
                                1218px
                            `}
              />
            </div>
          </CtaBoxContent>
        )}
      </CtaBox>
    </PageSection>
  );
};

export default PageSectionAboutHero;
